jQuery( document ).ready( function ( $ ) {

	$( '#wgwa_phone_number' ).on( 'keyup', function () {
		console.log( 'hi' );
		var _regex = new RegExp( /^((0\d{2}\-\d{7})|(0\d{8,9}))$/ );
		var _input = $( this );

		if ( !_regex.test( _input.val() ) ) {
			_input.addClass( 'invalid' );
		} else {
			_input.removeClass( 'invalid' );
		}

	} ).keyup();

} );